import { FlaskConical, Timer } from 'lucide-react'

const SubscriptionModulesSkeleton = () => {
  return (
    <section className="w-full mx-auto space-y-4">
      {/* Grid of Module Cards Skeleton */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {[...Array(8)].map((_, index) => (
          <ModuleCardSkeleton key={index} />
        ))}
      </div>
    </section>
  )
}

const ModuleCardSkeleton = () => {
  return (
    <div className="w-full rounded-md bg-white p-4 flex flex-col justify-between gap-4 border border-gray-100 shadow-sm">
      <div className="space-y-2.5">
        {/* Image skeleton */}
        <figure className="w-full aspect-[296/174] bg-gray-200 rounded-md animate-pulse"></figure>

        {/* Title skeleton */}
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 rounded w-3/4 animate-pulse"></div>
        </div>
      </div>

      <div>
        {/* Lab count skeleton */}
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 mb-3">
            <FlaskConical className="w-4 h-4 text-gray-300" />
            <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
          </div>
          <div className="flex items-center gap-1 mb-3">
            <Timer className="w-4 h-4 text-slate-300" />
            <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
          </div>
        </div>

        {/* Button skeleton */}
        <div className="w-full h-10 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  )
}

export default SubscriptionModulesSkeleton
